import React from 'react';
import Lottie from 'lottie-react';

const LottieAnimation = ({ 
  animationData, 
  isActive = false,
  className = "",
  style = {},
  slideIndex = 0
}) => {
  const baseStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    transform: 'scale(1.0)',
    overflow: 'hidden',
    ...style
  };

  const renderer = 'canvas';
  
  return (
    <div 
      className={`w-full h-full overflow-hidden ${className}`} 
      style={slideIndex === 2 ? { 
        maskImage: 'linear-gradient(to bottom, black 85%, transparent 100%)',
        WebkitMaskImage: 'linear-gradient(to bottom, black 85%, transparent 100%)'
      } : {}}
    >
      <Lottie
        animationData={animationData}
        loop={true}
        autoplay={true}
        style={baseStyle}
        renderer={renderer}
        rendererSettings={{
          preserveAspectRatio: 'xMidYMid meet',
          clearCanvas: true
        }}
      />
    </div>
  );
};

export default LottieAnimation;